import styled, { css } from "styled-components";
import { tokens, palette } from "@plataforma/components";
import { CircularLoading } from 'junto-ui';

/**
 * The styles are isolated in a variable to be used as a mixin if needed,
 * for example for inherited <a> elements automatically placed as a custom
 * menu item.
 */
const itemCss = css`
  ${tokens.font.s};

  display: flex;
  align-items: center;
  padding: ${tokens.spacing.s} 0;
  text-decoration: none;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: left;
  margin: 0 0 ${tokens.spacing.xs};
  color: inherit;
  font-family: inherit;

  &:hover,
  &:focus {
    text-decoration: none;
    outline: none;
    font-weight: ${tokens.font.weight.semibold};
    color: ${palette['color-brand-primary']};
  }

  // fixes the spacing among the upper list of items
  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    margin-bottom: 0;
  }
`

export const List = styled.nav`
  margin: 0;
  padding: 0;

  a {
    ${itemCss};
  }
`;

export const Item = styled.button`
  ${itemCss}
`;

export const Loader = styled(CircularLoading)`
  width: 16px;
  margin-left: auto;
`;